


import React, {useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Dialog,
  Divider,
  Grid,
  Link,

  Tabs,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import { v4 as uuid } from 'uuid'; 

import {  getTenantsIsLeadsInfoByphoneAction } from '@ivymobi/orbit-core/business/stats';
import { DownloadFile, getDocumentThumb, getFileSuffix, getFileType, isWeiXin, SampleSendEvent, Tenant } from '@ivymobi/orbit-core';
import Title from '../components/views/title';
import _, {isEmpty, isNull, pick } from 'lodash';
import { DeviceType, InnerUserContext, UserContext, WebSiteContext } from '../orbit-context';
import './selections.css';
import { loginAction, sendLoginMobileCodeAction, useOptions } from '@ivymobi/orbit-core/business/user';
import { getOutLibDocumentsAction, userShareEvent } from '@ivymobi/orbit-core/business/share';
import { DocumentGridCard } from '../documents/grid';
import PreviewDialog from '../documents/preview';
import {getTitleById } from './mapping';
import LoginForm from './component/loginForm';
import { LeadMustForm } from './component/leadform';
import { documentEventAction } from '@ivymobi/orbit-core/business/document';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)  },


}));
const queryParse = (query) => {
  query = query.substring(query.indexOf('?')+1);
  const array = query.split('&');
  const params = {};
  array.forEach(item => {
    const key = item.substring(0, item.indexOf('='));
    const value= decodeURIComponent(item.substring(item.indexOf('=')+1));
    params[key]= value;
  });
  return params;
};
export const RobotOutLibView = (props) => {
  const {doLogin} = props;

  const { id } = useParams<unknown>()??{id:null};
  const params = queryParse(location.search);
  const deviceType = useContext(DeviceType);

  const _title=getTitleById(params?.catalogType);

  const classes = useStyles(); 
  const history = useHistory();
  const {webInfo, acl} = useContext(WebSiteContext);


  const dispatch = useDispatch();
  // const [id, setId] = useState(null);
  const [useLoading, setUseLoading] = useState(false);
  const [documents, setDocuments] = useState({});
  const [{documentId, _bak_id, documentType}, setInfo] = useState({documentId:null, _bak_id:null, documentType:null});
  const [data, setData] = useState([]);
  const [firstDocs, setFirstDocs] = useState([]);
  const innerUser = useContext(InnerUserContext);
  const {user, token} = useContext(UserContext);
  const [isLogining, setIsLogining] = useState(false);
  const [leadProfile, setLeadProfile] = useState({});
  const [mustShow, setMustShow] = useState(false);
  const [selectDoc, setSelectDoc] = useState(null);

  const [eventID, setEventID] = useState(null);  // 埋点事件创建ID

  const  findPath = (dispatch, path, documents) => {
 
    const [docId] = path;
    const  doc = documents[docId];
    if (!doc) {
      dispatch(getOutLibDocumentsAction({tenantId: webInfo?.tnt_id, id: docId, type:params.catalogType  })).then(res => {
        const _docs = prev => res.reduce((acc, item) => {
          let id = '';
          if (item.type==='catalog'||item.type==='product') {
            id = item.realId;
          } else { 
            id = item.id;
          }
       
          acc[id] = item;
          return acc;
        }, {...prev});
        setDocuments(_docs);
      });
      return path;
    }
    const parentId = doc.parents?.[0];
   
    if (!parentId) {
      return path;
    }
    for (let i=0;i<firstDocs.length;i++) {
      if (firstDocs[i]===doc.id) {
        return path;
      }
    }
  
    return findPath(dispatch, [parentId, ...path], documents);
  };
  const handleSendCode = (phone, countryCode) => {
    return dispatch(sendLoginMobileCodeAction({ mobile: phone, countryCode }));
  };

  const handleCloseLogin = () => {
    if ((isEmpty(user) || !user)&&documents[id]?.type==='file'&&acl.eoi.includes('view'))
    {
      if (isWeiXin()&&  history.length<=1) {
        history.replace('/');
        return; 
      }
  
      history.goBack();
    }
    setIsLogining(false);
    // setLoginMode('');
    // setLoginMode('normal');
  };
  // 登录方法
  const handleAuth = async (data) => {
    // ------------------------方法重写----------------------
    // setMode('normal');
    const payload = Object.assign({}, data, pick(user, ['countryCode', 'phone']));
    const res = await dispatch(loginAction(payload)).catch(e => {
      console.error(e);
    });

    const res1 = await dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:res, phone:res.user.phone}));
    doLogin(res);
    setIsLogining(false);
    let show = false;
    if (documents[id]?.type==='file') {
      show = (!res1.data);
      setMustShow(show);
    } else {
      show = (!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view'));
      setMustShow(show);
    }

    return res;
  };
    // 输入信息可继续后 profile值
  const handleAuthAndShareEvent = async (data) => {
    const payload = Object.assign({}, data, pick(user, ['countryCode', 'phone']));
    let res;
    if (token) {
      await sendEvent('view', documents[id], payload);     
    } else {
      res = await dispatch(loginAction(payload));
      doLogin(res);
    }
  
    setMustShow(false);
    setLeadProfile(payload);
  };
    // 埋点事件
  const sendEvent = (type, document, detail = null, eventID = null) => {
    return SampleSendEvent(dispatch, userShareEvent, type, document, detail, eventID, innerUser?.userId?{id:innerUser?.userId}:user, {id:webInfo.tnt_id}, innerUser?.memberId);
  };
  useEffect(() => {
    if (!webInfo?.tnt_id)
      return; 
    setUseLoading(true);
    // setDocuments([])
    if (id) {
      dispatch(getOutLibDocumentsAction({ tenantId: webInfo?.tnt_id, id: id, type:params.catalogType })) 
      .then((res) => {
       
        const docs = [];
        for (let i=0;i<res.length;i++) {
          docs.push(res[i].id);
          if (res[i].id===id && res[i].type==='file') {
            let createId = null;
            if (getFileType(res[i]?.asset?.name??' ')==='pdf') {
              createId = uuid();
              setEventID(createId);
            }
            
            sendEvent('view', res[i], null, createId);
          }
        }
        if (!documents[id])
          setFirstDocs(docs);
        setDocuments(prev => res.reduce((acc, item) => {
          let id = '';
          if (item.type==='catalog'||item.type==='product') {
            id = item.realId;
          } else { 
            id = item.id;
          }
         
          acc[id] = item;
          return acc;
        }, {...prev}));
        setUseLoading(false);
      });
    } else {
      dispatch(getOutLibDocumentsAction({ tenantId: webInfo?.tnt_id, id: null, type:params.catalogType }))
      .then((res) => {
        if (!id) {
          const docs = [];
          for (let i=0;i<res.length;i++) {
            docs.push(res[i].id);
          }
          setFirstDocs(docs);
        }
        setDocuments(prev => res.reduce((acc, item) => {
          let id = '';
          if (item.type==='catalog'||item.type==='product') {
            id = item.realId;
          } else { 
            id = item.id;
          }
           
          acc[id] = item;
          return acc;
        }, {...prev}));
        setUseLoading(false);
      });
    }
      
     
    
  }, [dispatch, id, documentId, setDocuments, webInfo, _title]);

  const [routers, setRouters] =useState([]);
  useEffect(() => {
    if (!id) {
      setRouters([]); 
      return; 
    }
      
    let routers = [];
    if (documents[id]) {
      routers=findPath(dispatch, [id], documents); 
      setRouters(routers); 
    }
  }, [id]);
  useEffect(() => {
    console.log('routers====', routers);
    // props.setTitle("行业应用案例")
    const ps= [];
    let last = null;
    ps.push({ to:`/${params.catalogType}`, name:(getTitleById(params.catalogType)+(getTitleById(params.catalogType)==='伺服'?'系统':''))??'' });
    if (routers.length>0)
      ps.push({ to:`/${params.catalogType}/outlibs?catalogType=${params.catalogType}`, name:'资料下载'});
    for (let i=0;i<routers.length;i++) {
      console.log('routers====', routers[i]);
      if (i==(routers.length-1)) {
        last = routers[i];
      } else
        ps.push({to:`/${params.catalogType}/outlibs/${id}?catalogType=${params.catalogType}`, name:routers[i].name});
    }
    console.log('ps====', ps); 

    props.setParents(ps);
    props.setTitle(last?.name??'资料下载');

  }, [routers]);
  useEffect(() => { 
    
    if (documents[id]?.type!=='file'&& documents[id]?.type!=='weblink') {
      const data = ((documents[id]?(documents[id].documents?documents[id].documents:[]):firstDocs)).map(id => documents[id])
      .filter(i => {
        return i;
      })
      .map(doc => ({...doc,
        id: doc.id, name: doc.name, type: doc.type, acl: doc.acl, realId:doc.realId,
        thumbnail: getDocumentThumb(doc), link : `/${params.catalogType}/outlibs/${doc.id}?catalogType=${params.catalogType}`
      }));
      setData(data);
    }

  }, [documents, id, firstDocs, dispatch, _title]);
  const getLeadsInfo = useCallback(async() => {
    if (documents[id]?.type!='file') {
      return;
    }
    const res1 = await dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant: {id:webInfo.tnt_id}, user:{user, token}, phone: user.phone}));
    // 第一行： 有user信息且已经登录并且设置了下载需要填写访客信息，都通过为true  有不通过的执行下一条
    // 24.1.6   这里的判断逻辑有问题，第一行验证通过直接为true，必会弹框， 加了!res1.data后与预期相同，但是没完整测试过
    const show = user  &&(!res1.data) && (acl?.eoi?.includes('view')); 
    setMustShow(show);
  }, [webInfo, user, token, isLogining, acl, documents, id, leadProfile ]);
  useEffect(() => {
    console.log('11111');

    if (innerUser.userId)
      return;
    console.log('222', id, webInfo, user,);

    if ( !id || !webInfo||!user || !documents[id]) {
      return;
    }
    console.log('333');

    getLeadsInfo();
  }, [user, webInfo, dispatch, id, documents, webInfo]);
  useEffect(() => { 
    if ((!user)&&acl?.visitor_info?.length>0&&acl?.eoi.includes('view')&&documents[id]?.type==='file') {
      setIsLogining(true);
    }
    
  }, [acl, id, user, documents]);
  return (
    <div style={{height:deviceType==='computer'?'calc(100% - 30px)':'100%'}}>
      {deviceType==='computer'&&<Breadcrumbs style={{height:'30px'}} separator=">" maxItems={8}>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        {params.catalogType&&<Link
        //   key={b.id}
          color='textPrimary'
          to={`/${params.catalogType}`}
          component={RouteLink}
        >
          {(getTitleById(params.catalogType)+(getTitleById(params.catalogType)==='伺服'?'系统':''))} 
        </Link>}
        {routers.length==0&&<Typography color="textPrimary">
          资料下载
        </Typography>}
        {routers.length>0&&<Link
        //   key={b.id}
          color='textPrimary'
          to={`/${params.catalogType}/outlibs?catalogType=${params.catalogType}`}
          component={RouteLink}
        >
          资料下载
        </Link>}
        {routers.map(item => {
          if (!documents[item])
            return;
          // eslint-disable-next-line react/jsx-key
          return <Link
          //   key={b.id}
            color='textPrimary'
            to={`/${params.catalogType}/outlibs/${documents[item]?.id}?catalogType=${params.catalogType}`}
            component={RouteLink}
          >
            {documents[item]?.name} 
          </Link>;
        })}
      </Breadcrumbs>}
      <Box className={classes.pages}>
        <Box style={{width:deviceType==='computer'?'80%':'100%', paddingTop:deviceType==='computer'?'10px':'0px', paddingBottom:deviceType==='computer'?'16px':'0px', height:'100%', display:'flex', flexDirection:'column'}}> 
          <Box style={{display:'flex', justifyContent:'space-between'}}>
            {deviceType==='computer'&&<Title name={'资料下载'}></Title>}
          </Box> 
          <Box style={{flexGrow:'1', height:'0', background:'white', padding:documents[id]?.type==='file'?'0px':'20px', marginTop:deviceType==='computer'?'20px':'0px', overflow:'auto'}}>
            {(!documents[id]||documents[id]?.type==='folder')&&<Grid container spacing={2} direction="row">
              {data.map(item => {
                // eslint-disable-next-line react/jsx-key
                return (<Grid  
                  item xs={6} sm={4} md={3}
                > 
                  <DocumentGridCard
                    bDownload={_.get(item, ['acl', 'downloadable'], true)} 
                    onDownloadAction={(doc) => {
                      setSelectDoc(doc);

                      if (innerUser?.userId) {
                        sendEvent('download', doc);
                        // dispatch(userShareEvent({user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, share:{tenantId:webInfo?.tnt_id, id:'11111111-1111-1111-1111-111111111111', memberId:innerUser?.memberId}, document:doc, type:'download', detail:null}));
                        DownloadFile(doc.asset.url, doc.name+getFileSuffix(doc.name, doc?.asset?.name), window, dispatch);
                        return ;
                      }
                      if ((!user)&&acl?.visitor_info?.length>0&&(acl?.eoi.includes('download')||acl?.eoi.includes('view'))) {
  
                        setIsLogining(true);
                        return ;
                      }
                      if (user) {
                        dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:{user, token}, phone:user?.phone})).then( async res1 => {
                          if ((!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view'))) {
                            setMustShow((!res1.data) &&(acl?.eoi?.includes('download')||acl?.eoi?.includes('view')));
                            return;
                          }
                          sendEvent('download', doc);
            
                          // dispatch(userShareEvent({user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, share:{tenantId:webInfo?.tnt_id, id:'11111111-1111-1111-1111-111111111111', memberId:innerUser?.memberId}, document:doc, type:'download', detail:null}));
                          DownloadFile(doc.asset.url, doc.name+getFileSuffix(doc.name, doc?.asset?.name), window, dispatch);
                          return;
                          // window.open(doc.asset.url, "_blank"); 
                        });
                      } 

                      if (!user&&!acl?.eoi?.includes('download')) {
                        sendEvent('download', doc);

                        // dispatch(userShareEvent({user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, share:{tenantId:webInfo?.tnt_id, id:'11111111-1111-1111-1111-111111111111', memberId:innerUser?.memberId}, document:doc, type:'download', detail:null}));
  
                        // window.open(doc.asset.url, "_blank"); 
                        DownloadFile(doc.asset.url, doc.name+getFileSuffix(doc.name, doc?.asset?.name), window, dispatch);
  
                      }

                    }}
                    bDownload={true} document={item} isWarning={true} onMenuClick={() => {}} onClick={(e, id) => {
                    // history.push("/robot/outLibs?id="+id)
                    }} />
                </Grid>);
              })}

              {/* {documents.map(item => <Grid key={item.id}
                item xs={12} sm={4} md={3}
              >
                <DocumentGridCard document={item} isWarning={false} onMenuClick={()=>{}} onClick={()=>{}} />
              </Grid>)} */}
            </Grid>}
            {documents[id]?.type==='file'&&<Box style={{backgroundColor:'#e5e5e', height:'100%' }}>
              <FileDocument eventID={eventID} 
                handleDownload={(document) => { 
                  if ((!user)&&acl?.visitor_info?.length>0&&acl?.eoi.includes('download')) {
                    setIsLogining(true);
                    return;
                  }
                  dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant:{id:webInfo.tnt_id}, user:{user, token}, phone:user?.phone})).then( async res => {
              
                    setMustShow((!res.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')));
                    if (!((!res.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')))) {
                      //window.open(document.asset.url, "_blank");
                      // dispatch(userShareEvent({
                      //   user:{user:innerUser?.userId?{id:innerUser?.userId}:user}, 
                      //   share:{
                      //     tenantId:webInfo?.tnt_id,
                      //     id:'11111111-1111-1111-1111-111111111111',
                      //     memberId:innerUser?.memberId
                      //   }, 
                      //   document, 
                      //   type:'download', 
                      //   detail:null
                      // }));
                      sendEvent('download', document);
                      // SampleSendEvent(dispatch,userShareEvent,'download',document,null,getEventID(),innerUser?.userId?{id:innerUser?.userId}:user,{id:webInfo.tnt_id},innerUser?.memberId)
                      DownloadFile(document?.asset?.url, document?.name+getFileSuffix(document?.name, document?.asset?.name), window, dispatch);

                    }
                  });
                }} 
                document={documents[id]}
                user={{id:innerUser?.userId??user?.id, token:innerUser?.token??token}} 
                share={null}
                onClose={() => {}}
                onLikeFormOpen={() => {}}
              />

            </Box>}
            {/* 登录弹框 */}
            {(!innerUser.userId)&&isLogining&&<Dialog
              open={isLogining}
              maxWidth='xs'
            // onClose={handleCloseForm}
            >
              <LoginForm 
                user={user}
                doSendCode={handleSendCode}
                share={{tenant:webInfo}}
                onSubmit={handleAuth}
                onClose={handleCloseLogin}
              />
            </Dialog>}
            {(!innerUser.userId) && !isEmpty(user) && !isNull(user) && mustShow && 
              <Dialog
                open={acl?.visitor_info?.length>0&&mustShow}
                maxWidth='xs'
              // onClose={handleCloseForm}
              >
                <LeadMustForm
                  share={{tenant:{...webInfo, info:{industries:webInfo.tnt_info.industries}}, required:acl?.required}}
                  user={user}
                  visitorInfo={acl?.visitor_info ?? []}
                  leadProfile={leadProfile}
                  doSendCode={handleSendCode}
                  onSubmit={(e) => {
                    // setSubmitResult(e)

                    handleAuthAndShareEvent(e);                    
                    if (acl.eoi.includes('download')) {
                      sendEvent('download', documents[id]??selectDoc);
                      DownloadFile(
                        documents[id]?.type==='file'?documents[id].asset.url:selectDoc?.asset?.url, (documents[id]?.type==='file'?documents[id]?.name:selectDoc?.name)+getFileSuffix(documents[id]?.type==='file'?documents[id]?.name:selectDoc?.name, documents[id]?.type==='file'?documents[id]?.asset?.name:selectDoc?.asset?.name), window, dispatch);

                    }

                  }}
                  onClose={() => {setMustShow(false);
                    if (acl?.eoi?.includes('view')&&documents[id]?.type==='file') {
                      history.goBack();
                    }
                  }}
                />
              
              </Dialog>
            }
          </Box>
          
        </Box>
        

      </Box>
    </div>
  );
};
function FileDocument(props) {
  const {
    document, onClose, onLikeFormOpen, share, user, handleDownload, eventID
  } = props;
  // file type
  const isFile = document.type === 'file';
  const fileType = isFile && getFileType(document.name);

  const isPreview = false;
  return (
    <Box style={{backgroundColor: '#2F3941', height:'100%'}}>
      <PreviewDialog eventID={eventID} type='share' handleDownload={handleDownload} user={user} document={document} onClose={onClose} share={share} isPreview={isPreview} onLikeFormOpen={onLikeFormOpen} />
      {fileType !== 'pdf' &&  <Toolbar /> }

    </Box>
  );
}

export default function RobotOutLibContainer (props) {
  return (
    <RobotOutLibView {...props}

    />
  );
}